import { useSession } from '@/auth/index';
import { Text, CustomIcons, styled } from '@/theme/index';
import { DateUtil } from '@/utils/index';

export const FlexContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  gap: theme.spacing(1.5),
  fontWeight: 'bold',
  alignItems: 'center',
  fontFamily: theme.typography.fontFamily,
}));

export function DarkWebHeader({ updatedAt }: { updatedAt: string | null }) {
  const {
    session: { account },
  } = useSession();
  const dateParser = new DateUtil();
  return (
    <div>
      <Text variant="h1" sx={{ display: 'flex' }}>
        <CustomIcons.DarkWebIcon color="primary" fontSize="large" /> Dark Web
        Scan
      </Text>
      <FlexContainer>
        Scan completed on
        <Text variant="body1" color="primary">
          {account?.account.user_info.email}
        </Text>
      </FlexContainer>
      <FlexContainer>
        Last updated
        <Text variant="body1">
          {dateParser.parseDateFromString(
            updatedAt || '',
            'DDD',
            'yyyy-MM-dd HH:mm:ss ZZZ'
          ) || ''}
        </Text>
      </FlexContainer>
    </div>
  );
}
